module.exports = __webpack_public_path__ + "img/customs-logo-20260610.6330afca.jpg";